import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-trade-task-note',
  templateUrl: './trade-task-note.component.html',
  styleUrl: './trade-task-note.component.scss'
})
export class TradeTaskNoteComponent {

  @Input() noteText: string = '';

  constructor(private modal: NgbActiveModal) { }

  saveNote() {
    this.modal.close(this.noteText);
  }

  cancelNote() {
    this.modal.dismiss();
  }
}
